import {
  setIsLoadingPremisses,
  setIsLoadingDirectDebit,
  setPremisesError,
  setDirectDebitError,
  setSuccessPremises,
  setSuccessDirectDebit
} from './direct-debit-slice';
import {
  validateBankAccount,
  getDirectDebitPaymentToken
} from 'api/direct-debit';
import { getPremises } from 'api/premises';
import { getErrors } from 'api/client';

export const validateBankAccountThunk = (
  bankAccountDetails,
  requestConfig
) => async (dispatch) => {
  try {
    dispatch(setIsLoadingDirectDebit());
    const response = await validateBankAccount(
      bankAccountDetails,
      requestConfig
    );
    const bankValidationError = response.errors?.[0];

    if (['500', '400', '422', '412'].includes(bankValidationError?.status)) {
      dispatch(setIsLoadingDirectDebit(false));
      return Promise.reject([bankValidationError]);
    }

    dispatch(setSuccessDirectDebit(response));
    return Promise.resolve(response);
  } catch (error) {
    const errors = getErrors(error);
    errors && dispatch(setDirectDebitError(errors));

    return Promise.reject(errors);
  }
};

export const getDirectDebitPaymentTokenThunk = (bankAccountDetails) => async (
  dispatch
) => {
  try {
    dispatch(setIsLoadingDirectDebit());

    const response = await getDirectDebitPaymentToken(bankAccountDetails);
    dispatch(setSuccessDirectDebit(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setDirectDebitError(errors));

    return Promise.reject(errors);
  }
};

export const getAddressListThunk = (postcode, requestConfig) => async (
  dispatch
) => {
  try {
    dispatch(setIsLoadingPremisses());
    const result = await getPremises(postcode, requestConfig);

    dispatch(setSuccessPremises(result));

    return Promise.resolve(result);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setPremisesError(errors));

    return Promise.reject(errors);
  }
};
